import { z } from "zod";

import { HotelSetUpInputSchema } from "@/lib/zod/__generated__/validation-schema";

import type { ZodError } from "zod";

const ERROR_MESSAGES = {
	validHotelName: "ホテル名を入力してください",
	validEmail: "正しいメールの形式ではありません",
};

const SetupInputSchema = HotelSetUpInputSchema.extend({
	hotelName: z.string().min(1, { message: ERROR_MESSAGES.validHotelName }).max(50),
	hotelEmailAddress: z.string().email(),
	totalRoomNum: z
		.number()
		.int()
		.min(0)
		.max(8_000)
		.refine((val) => typeof val === "number", {
			message: "部屋数は入力が必須の項目です",
		}),
});

/**
 *
 * @description ホテル作成用のバリデーションスキーマ
 *
 */
export const SetupInputZodSchema = SetupInputSchema;

export type SetupInputZodSchemaType = z.infer<typeof SetupInputZodSchema>;

export type SetupInputZodParseError = ZodError<SetupInputZodSchemaType>;
